import { AiOutlineClose } from "react-icons/ai";
import { RiSearch2Line } from "react-icons/ri";

const LookupSearch = ({ setisLookup, ...rest }) => {
  return (
    <div className="border-b border-solid border-gray-200 relative">
      <div className="absolute transform -translate-y-1/2 top-1/2 left-3">
        <RiSearch2Line className="text-zinc-500" />
      </div>
      <input
        {...rest}
        className="w-full h-full px-8 py-4 outline-none"
        placeholder="Search for anything"
      />
      <AiOutlineClose
        size={18}
        onClick={() => setisLookup(false)}
        className="md:invisible visible md:pointer-events-none pointer-events-auto absolute right-3 top-4"
      />
    </div>
  );
};

export default LookupSearch;
